import service from '../service';
import { connect, ReduxState, MyStore, reducers } from '../redux';

const LOCAL: string = '$$/system/language/state';

type StateType = string;

interface LanguageItem {
    key: string;
    value?: string;
    resolve?: (value: string) => void;
}

class Language {

    /** 计时器 */
    private timer: any;

    /** 默认中文 */
    private _state: StateType = window.localStorage.getItem(LOCAL);

    /** 等待中的请求后的 */
    private waitlist: LanguageItem[] = [];

    /** 已经请求的数据字典 */
    private map: any = {};

    constructor() {
        this.windowStorage();
    }

    /** 当前语言环境 */
    public get state(): StateType {
        return this._state;
    }
    public set state(value: StateType) {
        if (this._state === value) {
            return;
        }
        this._state = value;
        window.localStorage.setItem(LOCAL, value);
        MyStore.instance.dispatch(reducers.system.ActionTypes.addLanguageVersion, null);
    }

    /** 获取制定key的文本 */
    public get = (key: string, parameter?: string[]): string => {

        const lang = this.map[this.state];
        if (lang && lang[key]) {
            return this.stencil(lang[key], parameter);
        }

        this.startTimer({ key });

        return '';
    }

    /** 获取制定key的文本 异步 */
    public request = (key: string, parameter?: string[]): Promise<string> => new Promise<string>((resolve: (value: string) => void) => {

        const myresolve = (value: string): void => {
            resolve(this.stencil(value, parameter));
        };

        const lang = this.map[this.state];
        if (lang && lang[key]) {
            myresolve(lang[key]);
            return;
        }

        this.startTimer({ key, resolve: myresolve });
    })

    /** 关联ui触发渲染 */
    public associate(dom: any) {
        return connect((state: ReduxState) => ({
            languageVersion: state.system.languageVersion,
        }))(dom);
    }

    /** 字符串模版替换 */
    public stencil = (str: string, parameter?: string[]) => {
        if (parameter) {
            parameter.forEach((value, index)=>{
                str = str.replace(new RegExp(`\{${index}\}`, 'g'), value);
            });
        }
        return str;
    }

    /** 监听 LOCAL */
    private windowStorage = () => {
        window.addEventListener('storage', e => {
            if (e.key !== LOCAL) { return; }
            this.state = e.newValue;
        });
    }

    /** 开始准备 */
    private startTimer = (value: LanguageItem) => {
        this.waitlist.push(value);
        if (!this.timer) {
            this.timer = setTimeout(async () => {
                this.requestList(this.waitlist);
                this.waitlist = [];
                this.timer = null;
            }, 200);
        }
    }

    /** 开始请求预备列表 */
    private requestList = async (waitlist: LanguageItem[]): Promise<void> => {
        const keys: string[] = [];

        waitlist.forEach(value => {
            keys.push(value.key);
        });

        const url = "/kxl-internationalization-service/integrate/getLanguageVal";
        const getLanguageVal = await service.post(url, { keys: unique(keys) }).end(null);
        if (getLanguageVal.err) {
            waitlist.forEach(value => {
                value.resolve && value.resolve('');
            });
        } else {
            const langEname = this.state = getLanguageVal.res.langEname;
            this.map[langEname] = this.map[langEname] || {};

            keys.forEach(value => {
                this.map[langEname][value] = getLanguageVal.res.vals[value] || ' ';
            });

            waitlist.forEach(value => {
                value.resolve && value.resolve(getLanguageVal.res.vals[value.key] || '');
            });

            MyStore.instance.dispatch(reducers.system.ActionTypes.addLanguageVersion, null);
        }
    }
}

/** 语言绑定后的props */
export interface LanguageProps {
    languageVersion: number;
}

export default new Language();

/** 数组去从 */
function unique(arr: string[]) {
    const res = new Map();
    return arr.filter((a) => !res.has(a) && res.set(a, 1));
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/language/index.ts